import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * New Preference Icon
 *
 * @file NewPreference.jsx
 * @author Satyaki Bose
 */

const NewPreference = props => (
    <SvgIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6892 17H20.3109L21.9132 21.5018C22.0195 21.8006 22.3016 22 22.6178 22H23.5012C23.7767 
        22 24 21.776 24 21.4997C24 21.4423 23.9902 21.3854 23.971 21.3314L16.6744 0.830593C16.4428 
        0.179998 15.7294 -0.159112 15.0808 0.0731699C14.7286 0.199299 14.4515 0.477318 14.3257 0.830593L8.44836 
        17.344L5.98665 10.4491C5.78238 9.87692 5.15297 9.5787 4.58083 9.78297C4.27015 9.89389 4.02566 10.1384 
        3.91474 10.4491L0.0292492 21.3319C-0.0636005 21.5919 0.0719509 21.878 0.332016 21.9709C0.385975 21.9902 
        0.442841 22 0.500135 22H1.12031C1.43729 22 1.72005 21.8007 1.82664 21.5022L2.36296 20H7.50305L7.02918 
        21.3314C6.93655 21.5917 7.07177 21.878 7.3312 21.9709C7.38503 21.9901 7.44176 22 7.49891 22H8.38236C8.69857 
        22 8.98063 21.8006 9.08696 21.5018L10.6892 17ZM11.4011 15L15.5001 3.4832L19.5991 15H11.4011ZM6.91362 
        18.25H2.98776L4.95069 12.7521L6.91362 18.25Z"
        fill="currentColor"
      />
    </SvgIcon>
  );

  export default NewPreference;